import * as React from 'react';

type LegacyBomCheckboxIconProps = {
  checked?: boolean,
};

const LegacyBomCheckboxIcon = ({ checked = false }: LegacyBomCheckboxIconProps) => (
  <span
    aria-hidden="true"
    className={`legacy-bom-checkbox-icon${checked ? ' legacy-bom-checkbox-icon--checked' : ''}`}
  >
    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24">
      <rect x="2" y="2" width="20" height="20" rx="2" />
      {checked && <path d="M6.5 12.5l3.5 3.5 7.5-7.5" />}
    </svg>
  </span>
);

export const getLegacyBomControlProps = (enabled = false, className = '') => {
  if (!enabled) {
    return className ? { className } : {};
  }

  return {
    checkedIcon: <LegacyBomCheckboxIcon checked={true} />,
    className: `${className} legacy-bom-selection-control`.trim(),
    disableRipple: true,
    icon: <LegacyBomCheckboxIcon />,
  };
};
